import { User, UserParams, UserResponse } from '../../models/user.models';

export function mapUserResponseToModel(response: UserResponse): User {
  return {
    userId: response.user_id ?? response.id,
    firstName: response.first_name,
    lastName: response.last_name,
    fullName: `${response.first_name} ${response.last_name}`,
    email: response.email,
    isAdmin: response.is_admin,
    isLincUser: response.is_linc_user,
    entities: response.business_entity_codes,
    permissions: response.permission_ids,
    active: response.active_flag,
  };
}

export function mapUserToParams(user: User): UserParams {
  return {
    first_name: user.firstName,
    last_name: user.lastName,
    email: user.email,
    is_admin: user.isAdmin,
    is_linc_user: user.isLincUser,
    business_entity_codes: user.entities,
    permission_ids: user.permissions,
  };
}